export default __webpack_public_path__ + "static/media/70.daf89fb6.jpeg";